import { render, staticRenderFns } from "./EnvironmentPage.vue?vue&type=template&id=2afaf016&scoped=true&"
import script from "./EnvironmentPage.vue?vue&type=script&lang=js&"
export * from "./EnvironmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afaf016",
  null
  
)

export default component.exports